'use strict';

window.config = window.config || {};

window.config.constants = {
  apiVersion: 20211004
};
